"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),t=(function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}(e),e.createContext());exports.default=t;
//# sourceMappingURL=wizard-context.js.map
